import { motion, useReducedMotion } from 'framer-motion';
import React from 'react';

interface SxRevealProps {
  children: React.ReactNode;
  className?: string;
  delay?: number;
  /** 入场位移距离。参考站的位移幅度很小（12–20px），克制是关键 */
  y?: number;
  /** 提前多少触发。负值表示元素露出一部分后才开始 */
  margin?: string;
}

const EASE = [0.22, 1, 0.36, 1] as const;

/**
 * 落地页滚动揭示原语。
 *
 * 位移默认只有 16px：参考站的入场动画幅度极小，靠的是"几乎察觉不到但确实存在"
 * 的位移营造精密感。大幅度滑入是营销页的做法，与工程调性相悖。
 *
 * reduced-motion 时位移归零、时长压到 0.01s，只保留 opacity 变化。
 */
const SxReveal: React.FC<SxRevealProps> = ({
  children,
  className = '',
  delay = 0,
  y = 16,
  margin = '-80px',
}) => {
  const reduce = useReducedMotion();
  return (
    <motion.div
      initial={{ opacity: 0, y: reduce ? 0 : y }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: reduce ? 0.01 : 0.7, delay: reduce ? 0 : delay, ease: EASE }}
      viewport={{ once: true, margin }}
      className={className}
    >
      {children}
    </motion.div>
  );
};

export default SxReveal;
